<script>
    import { Router, Route, Link } from 'svelte-routing';
    import Header from '../components/Header.svelte';
    import { cookieConsent } from '../store/cookieStore.js';

    function resetConsent() {
        cookieConsent.set(null);
    }
</script>

<style>
.about {
    color: black;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 15px; /* Rundade hörn */
    padding: 40px; /* Inre marginal */
    transition: transform 0.6s ease, box-shadow 0.6s ease;
    font-family: 'MuseoModerna'
}

.about-header {
    font-size: 2em;
    margin-bottom: 20px;
    position: relative;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}


.about-header::after {
    content: '';
    position: absolute;
    transform: translateX(-50%);
    bottom: -10px;
    left: 50%;
    width: 400px;
    height: 2px;
    background-color: #999; /* Linje mellan header och brödtext */
}

@keyframes rotateBlocks {
  0%   { transform: rotate(0deg); }
  20%  { transform: rotate(180deg); }  /* Fast rotation: 180deg in 20% of time */
  50%  { transform: rotate(225deg); }  /* Slow rotation: 45deg in 30% of time */
  70%  { transform: rotate(315deg); }  /* Fast rotation: 90deg in 20% of time */
  100% { transform: rotate(360deg); }  /* Slow rotation: 45deg in 30% of time */
}

.page-container {
    min-height: 100vh; /* Ensures the container covers the full viewport height */
    width: 100%;
    text-align: left;
}

.about-contact-container {
    z-index: 100;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    padding-top: 50px;
}

.index-number {
    color: #999;
    font-size: 2em;
}

.index-text {
    margin-left: 15px;
}

.about-section-title {
    font-family: 'MuseoModerna';
    font-size: 2em;
}

.divider {
    height: 2px; /* Thickness of the divider */
    background-color: #999; /* Color of the divider */
    margin: 15px auto; /* Spacing around the divider */
    border-radius: 5px; /* Optional: Adds rounded edges */
}

.index-text {
    position: relative;
    text-decoration: none;
    color: inherit;
    display: inline-block;
    transition: color 0.3s ease;
}

.index-number {
    margin-right: 15px;
}

/* Divider styles */
.index-text::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px; /* Adjusts the position of the divider below the text */
    width: 0; /* Initial width of the divider */
    height: 2px; /* Thickness of the divider */
    background-color: var(--hover); /* Color of the divider */
    transition: width 0.3s ease; /* Smooth transition for the divider growth */
}

/* Hover effect */
.index-text:hover::after {
    width: 100%; /* Grows to the full width of the text */
}

/* Optional: Change text color on hover */
.index-text:hover {
    color: var(--hover);
}

   @media (max-width: 840px) {
       .about {
           width: 70%;
       }

       .about-contact-container {
           padding-left: 20px;
           padding-right: 20px;
           width: 90% !important;
       }

       .about-header::after {
           width: 80%;
           left: 40%;
   }
}

</style>

<!-- Content -->
<div class="page-container">
    <Header />
        <div class="about">  
            <!-- About Text -->
            <div class="about-header">Innehåll</div>
                <br>
                <a href="#allmant-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">01</span>
                    <span style="margin-left: 15px;">allmänt</span>
                </a>
            <br>
                <a href="#tjanst-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">02</span>
                    <span style="margin-left: 15px;">tjänstebeskrivning</span>
                </a>
            <br>
                <a href="#ansvar-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                    <span class="index-number">03</span>
                    <span style="margin-left: 15px;">ansvarsfriskrivning</span>
                </a>
            <br>
            <a href="#uppladdat-innehall-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">04</span>
                <span style="margin-left: 15px;">ansvar för uppladdat innehåll</span>
            </a>
            <br>
            <a href="#immateriella-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">05</span>
                <span style="margin-left: 15px;">immateriella rättigheter</span>
            </a>
            <br>
            <a href="#person-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">06</span>
                <span style="margin-left: 15px;">personuppgiftshantering</span>
            </a>
            <br>
            <a href="#andring-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">07</span>
                <span style="margin-left: 15px;">ändringar av villkor</span>
            </a>
            <br>
            <a href="#lag-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">08</span>
                <span style="margin-left: 15px;">tillämplig lag och tvistelösning</span>
            </a>
            <br>
            <a href="#org-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">09</span>
                <span style="margin-left: 15px;">organisationsnummer och medlemskap</span>
            </a>
            <br>
            <a href="#prenumeration-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">10</span>
                <span style="margin-left: 15px;">prenumerationer och betalningar</span>
            </a>
            <br>
            <a href="#trial-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">11</span>
                <span style="margin-left: 15px;">provperioder</span>
            </a>
            <br>
            <a href="#cancellation-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">12</span>
                <span style="margin-left: 15px;">uppsägning och återbetalning</span>
            </a>
            <br>
            <a href="#userdata-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">13</span>
                <span style="margin-left: 15px;">användardata och kontoinformation</span>
            </a>
            <br>
            <a href="#cookies-section" class="index-text" style="text-decoration: none; color: inherit; margin-left: 0px;">
                <span class="index-number">14</span>
                <span style="margin-left: 15px;">cookies och spårningsteknik</span>
            </a>
        </div>

    <div id="allmant-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Allmänt</span>
            <div class="divider"></div>
            <p>
                Dessa allmänna villkor (”Villkoren”) reglerar användningen av applikationen och tjänsten Boanalys, 
                vilken tillhandahålls av Boan AB, ett svenskt bolag med organisationsnummer 559509-9101 och säte i STOCKHOLM. 
                Genom att registrera dig för eller på annat sätt använda Boanalys (”Tjänsten”) 
                bekräftar du att du har läst, förstått och godkänner Villkoren och förbinder dig att följa dem.
            </p>
        </div>
    </div>

    <div id="tjanst-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Tjänstebeskrivning</span>
            <div class="divider"></div>
            <p>
                Boanalys tillhandahåller användare tillgång till ekonomisk data om svenska bostadsrättsföreningar. 
                Informationen baseras på offentlig data, årsredovisningar samt övrig finansiell information som analyseras med hjälp av AI-baserade metoder. 
                Syftet med Tjänsten är att underlätta för köpare, boende, mäklare, banker och andra intressenter att snabbt få en översikt över 
                centrala nyckeltal, ekonomisk ställning och relevant historik för en bostadsrättsförening.
            </p>
        </div>
    </div>

    <div id="ansvar-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Ansvarsfriskrivning</span>
            <div class="divider"></div>
            <p>
                <strong>Ingen garanti för korrekthet</strong>: All information och data i Tjänsten tillhandahålls ”i befintligt skick” utan några uttryckliga eller 
                underförstådda garantier avseende fullständighet, noggrannhet, riktighet, tillförlitlighet eller aktualitet. 
                Den tillgängliga informationen bygger på tredjepartsdatakällor, offentliga register samt AI-genererade analyser, 
                vilka kan vara ofullständiga, felaktiga eller inaktuella.
            </p>
            <p>
                <strong>Inget råd eller rekommendation</strong>: Informationen i Tjänsten ska inte betraktas som juridisk, ekonomisk, finansiell eller annan professionell rådgivning. 
                Du bör inte enbart förlita dig på Tjänsten vid beslut som rör köp, försäljning, finansiering eller förvaltning av bostadsrätter. 
                Boan AB rekommenderar alltid att du kompletterar informationen med egna undersökningar och vid behov konsulterar oberoende experter.
            </p>
            <p>
                <strong>Ansvarsfrihet för skador</strong>: Boanalys och Boan AB ansvarar inte för direkta, indirekta, tillfälliga, särskilda eller följdskador, förlust av data, intäkt, 
                inkomst, affärsmöjlighet eller förväntad besparing, som på något sätt uppkommer till följd av användning av Tjänsten eller dess information.
            </p>
            <p>
                <strong>Tekniska störningar</strong>: Boan AB garanterar inte att Tjänsten kommer att vara oavbruten eller felfri, eller att fel kommer åtgärdas omedelbart. 
                Eventuella driftstopp, buggar, virus eller andra tekniska problem kan uppstå utan förvarning. 
            </p>
        </div>
    </div>

    <div id="uppladdat-innehall-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Ansvar för Uppladdat Innehåll</span>
            <div class="divider"></div>
            <p>
                Du som användare är fullt ansvarig för det material och den data du laddar upp till Tjänsten. Genom att ladda upp en fil, 
                såsom en årsredovisning eller annan dokumentation, intygar du att informationen är korrekt, fullständig och inte har manipulerats 
                eller på annat sätt gjorts vilseledande. Boan AB förbehåller sig rätten att granska uppladdat material och vidta rättsliga åtgärder 
                om det upptäcks att en användare medvetet har laddat upp felaktig eller manipulerad data. Sådana åtgärder kan inkludera, men är inte 
                begränsade till, omedelbar avstängning från Tjänsten, polisanmälan samt krav på skadestånd för eventuella förluster som Boan AB eller 
                tredje part lider.
            </p>
        </div>
    </div>

    <div id="immateriella-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Immateriella Rättigheter</span>
            <div class="divider"></div>
            <p>
                Allt innehåll i Tjänsten, såsom logotyper, grafiska element, texter, data, kod och bakomliggande teknologi, tillhör Boan AB eller dess licensgivare. 
                All reproduktion, distribution, modifiering eller annan användning av sådant material utan skriftligt medgivande från Boan AB är förbjuden.
            </p>
        </div>
    </div>

    <div id="person-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Personuppgiftshantering</span>
            <div class="divider"></div>
            <p>
                Om personuppgifter behandlas i samband med Tjänsten, sker detta i enlighet med gällande dataskyddslagstiftning, inklusive Dataskyddsförordningen (GDPR). 
                Information om hur Boan AB hanterar personuppgifter, användarens rättigheter samt kontaktuppgifter för dataskyddsfrågor finns 
                i Boan AB:s Integritetspolicy, som kan tillhandahållas separat.
            </p>
        </div>
    </div>

    <div id="andring-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Ändringar av Villkor</span>
            <div class="divider"></div>
            <p>
                Boan AB förbehåller sig rätten att när som helst ändra dessa Villkor. Om väsentliga ändringar görs, 
                kommer du att meddelas på ett ändamålsenligt sätt, till exempel genom ett meddelande i Tjänsten eller via e-post. 
                Genom att fortsätta använda Tjänsten efter att ändringar trätt i kraft, anses du ha accepterat de uppdaterade Villkoren.
            </p>
        </div>
    </div>

    <div id="lag-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Tillämplig Lag och Tvistelösning</span>
            <div class="divider"></div>
            <p>
                Dessa Villkor ska tolkas och tillämpas i enlighet med svensk lag. Eventuella tvister som uppstår med anledning av Tjänsten eller dessa Villkor 
                ska i första hand lösas genom förhandlingar mellan parterna. Om parterna inte kan enas ska tvisten prövas av svensk allmän domstol, 
                med STOCKHOLM tingsrätt som första instans.
            </p>
        </div>
    </div>

    <div id="org-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Organisationsnummer och Medlemskap</span>
            <div class="divider"></div>
            <p>
                Genom att registrera eller uppdatera ett organisationsnummer i Tjänsten bekräftar användaren på heder och samvete att hen är medlem 
                i den angivna bostadsrättsföreningen. Användaren ansvarar för att det angivna organisationsnumret är korrekt och tillhör 
                den förening som användaren är medlem i.
            </p>
            <p>
                <strong>Felaktiga uppgifter:</strong> Att medvetet ange felaktiga eller vilseledande organisationsnummer kan leda till omedelbar 
                avstängning från Tjänsten. Boan AB förbehåller sig rätten att begära dokumentation som bekräftar medlemskap i en bostadsrättsförening.
            </p>
            <p>
                <strong>Ändring av organisationsnummer:</strong> Användare kan när som helst uppdatera sitt organisationsnummer via sin profil. 
                Vid varje ändring bekräftar användaren på nytt sitt medlemskap i den nya föreningen.
            </p>
            <p>
                <strong>Användning av uppgifter:</strong> Organisationsnummer används för att koppla användaren till relevant information om 
                bostadsrättsföreningen och för att anpassa tjänstens innehåll. Uppgiften delas inte med tredje part utan användarens uttryckliga samtycke.
            </p>
        </div>
    </div>

    <div id="prenumeration-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Prenumerationer och Betalningar</span>
            <div class="divider"></div>
            <p>
                Boanalys erbjuder olika prenumerationsplaner (Plus och Pro) med varierande funktionalitet och prisnivåer. 
                All betalning och prenumerationshantering sker via Stripe, en tredjepartstjänst för säkra betalningar. 
                Genom att välja en prenumerationsplan godkänner användaren även Stripes användarvillkor.
            </p>
            <p>
                <strong>Priser och fakturering:</strong> Prenumerationsavgifter debiteras månadsvis i förskott. 
                Aktuella priser visas tydligt vid köptillfället och kan ändras med minst 30 dagars varsel. 
                Alla priser anges inklusive moms där så är tillämpligt.
            </p>
            <p>
                <strong>Automatisk förnyelse:</strong> Prenumerationer förnyas automatiskt varje månad tills användaren säger upp sitt abonnemang. 
                Användaren ansvarar för att säga upp sitt abonnemang innan nästa debiteringsperiod om de inte längre önskar använda tjänsten.
            </p>
            <p>
                <strong>Betalningsmetoder:</strong> Betalning sker via Stripe och stöder kreditkort, debetkort och andra betalningsmetoder 
                som Stripe erbjuder. Boan AB lagrar inte några betalningsuppgifter - all sådan information hanteras säkert av Stripe.
            </p>
        </div>
    </div>

    <div id="trial-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Provperioder</span>
            <div class="divider"></div>
            <p>
                Nya användare kan erbjudas en kostnadsfri provperiod för att testa Tjänstens funktioner. Provperiodens längd och villkor 
                specificeras vid registreringstillfället och kan variera beroende på kampanjer och erbjudanden.
            </p>
            <p>
                <strong>Övergång till betald prenumeration:</strong> Om användaren inte säger upp sitt abonnemang innan provperiodens slut, 
                övergår kontot automatiskt till den valda betalda prenumerationsplanen. Första debiteringen sker omedelbart efter provperiodens slut.
            </p>
            <p>
                <strong>Uppsägning under provperiod:</strong> Användaren kan när som helst säga upp sitt abonnemang under provperioden utan kostnad. 
                Vid uppsägning under provperioden behåller användaren tillgång till premiumfunktioner till provperiodens slut.
            </p>
            <p>
                <strong>Begränsningar:</strong> Provperioder är normalt begränsade till en per användare och e-postadress. 
                Boan AB förbehåller sig rätten att neka provperioder eller avsluta dem i förtid vid misstänkt missbruk.
            </p>
        </div>
    </div>

    <div id="cancellation-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Uppsägning och Återbetalning</span>
            <div class="divider"></div>
            <p>
                Användare kan när som helst säga upp sitt abonnemang via sin profil på Boanalys eller direkt genom Stripes kundsupport. 
                Uppsägning träder i kraft vid slutet av den aktuella faktureringsperioden - användaren behåller tillgång till 
                premiumfunktioner fram till dess.
            </p>
            <p>
                <strong>Ingen återbetalning:</strong> Prenumerationsavgifter återbetalas normalt inte för redan fakturerade perioder, 
                inklusive vid uppsägning mitt i en faktureringsperiod. Undantag kan göras efter individuell bedömning i särskilda fall 
                eller där konsumentlagstiftning kräver det.
            </p>
            <p>
                <strong>Tekniska problem:</strong> Om Tjänsten är otillgänglig under en längre period på grund av tekniska problem hos Boan AB, 
                kan användare ha rätt till proportionell återbetalning eller förlängning av prenumerationsperioden.
            </p>
            <p>
                <strong>Kontostängning:</strong> Boan AB förbehåller sig rätten att säga upp eller stänga av användarkonton som bryter mot 
                dessa Villkor. I sådana fall sker normalt ingen återbetalning av redan betalda avgifter.
            </p>
        </div>
    </div>

    <div id="userdata-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Användardata och Kontoinformation</span>
            <div class="divider"></div>
            <p>
                För att skapa och upprätthålla ett användarkonto samlar Boan AB in och lagrar följande information: 
                e-postadress, förnamn, efternamn, organisationsnummer (valfritt), företagsstatus samt prenumerationsinformation 
                från Stripe. All denna information behandlas i enlighet med gällande dataskyddslagstiftning.
            </p>
            <p>
                <strong>Uppdatering av kontoinformation:</strong> Användare kan när som helst uppdatera sin personliga information 
                via sin profil på Boanalys.
                Organisationsnummer kan läggas till, ändras eller tas bort när som helst.
            </p>
            <p>
                <strong>Radering av konto:</strong> Användare har rätt att begära radering av sitt konto och all associerad data. 
                Begäran om radering görs via e-post till Boan AB. Efter radering kan viss information behållas under begränsad tid 
                för juridiska eller administrativt nödvändiga ändamål.
            </p>
            <p>
                <strong>Dataportabilitet:</strong> Användare har rätt att begära utdrag av den personliga information som lagras 
                om dem. Sådana begäranden hanteras i enlighet med GDPR och annan tillämplig dataskyddslagstiftning.
            </p>
            <p>
                <strong>Tredjepartstjänster:</strong> För hantering av betalningar och prenumerationer använder Tjänsten Stripe. 
                Användarens betalningsinformation och vissa kontaktuppgifter delas med Stripe för detta ändamål och regleras av Stripes integritetspolicy.
            </p>
        </div>
    </div>

    <div id="cookies-section" class="about-contact-container" style="padding-bottom: 100px;">
        <div>
            <span class="about-section-title">Cookies och Spårningsteknik</span>
            <div class="divider"></div>
            <p>
                För att förbättra användarupplevelsen och förstå hur Tjänsten används samlar vi in anonym statistik med hjälp av Google Analytics. 
                Detta verktyg använder cookies, vilka är små textfiler som placeras på din enhet. Informationen som samlas in är helt avidentifierad 
                och kan inte spåras tillbaka till dig som individ. Den data vi analyserar inkluderar information som vilka sidor som besöks, 
                hur länge en besökare stannar på webbplatsen och vilken typ av enhet som används.
            </p>
            <p>
                Vi använder denna data för att optimera Tjänstens funktionalitet, identifiera tekniska problem och fatta datadrivna beslut om 
                framtida utveckling. Du har alltid möjlighet att neka till användningen av dessa cookies via den cookie-banner som visas vid ditt första besök. 
                Om du nekar kommer ingen spårningsdata att samlas in.
            </p>
            
            <br>
            <span class="about-section-title" style="font-size: 1.5em; display: block;">Hantera ditt samtycke</span>
            <p>
                Här kan du se och ändra ditt nuvarande val för användning av cookies för statistik.
            </p>
            {#if $cookieConsent === 'true'}
                <p><strong>Ditt nuvarande val:</strong> Du har accepterat användningen av cookies.</p>
                <button on:click={() => cookieConsent.set('false')} class="primary-button">Avböj cookies</button>
            {:else if $cookieConsent === 'false'}
                <p><strong>Ditt nuvarande val:</strong> Du har avböjt användningen av cookies.</p>
                <button on:click={() => cookieConsent.set('true')} class="primary-button">Acceptera cookies</button>
            {:else}
                <p><strong>Ditt nuvarande val:</strong> Du har ännu inte gjort ett val.</p>
                <button on:click={() => cookieConsent.set('true')} class="primary-button">Acceptera cookies</button>
                <button on:click={() => cookieConsent.set('false')} class="secondary-button">Avböj cookies</button>
            {/if}
             <button on:click={resetConsent} style="margin-left: 10px;" class="secondary-button">Återställ val</button>
        </div>
    </div>
</div>
